import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3777f0e3")

_pushScopeId("data-v-3777f0e3")
const _hoisted_1 = {
  class: "container popup-container",
  id: "providers-filter"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "providers-filter-title" }
const _hoisted_4 = { class: "filter-block" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "provider-name" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "provider-name" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "provider-name" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { for: "provider-name" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "provider-companyId" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "provider-email" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "provider-mobile" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "provider-username" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "provider-subscription-select" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "provider-status-select" }
const _hoisted_26 = { class: "position-relative" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { for: "product-select" }
const _hoisted_29 = { class: "filter-block-footer" }
const _hoisted_30 = { class: "second-row-btns" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "middle-hidden-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('button.filters')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('providers.name')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.provider = $event)),
            name: "provider-name",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.provider]
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('providers.id')), 1),
          _withDirectives(_createVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.providerIdNoHash = $event)),
            name: "provider-id",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.providerIdNoHash]
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('providers.hashId')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.providerId = $event)),
            name: "provider-id",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.providerId]
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('providers.company')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.company = $event)),
            name: "provider-company",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.company]
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('providers.companyId')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.companyId = $event)),
            name: "provider-companyId",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.companyId]
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('providers.email')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.email = $event)),
            name: "provider-email",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.email]
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('providers.mobile')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.mobile = $event)),
            name: "provider-mobile",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.mobile]
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('providers.username')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter.username = $event)),
            name: "provider-username",
            class: "bookit-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.username]
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('providers.subscriptionType')), 1),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.subscriptionId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.subscriptionId = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.subscriptions,
              id: "provider-subscription-select",
              "close-on-select": true
            }, null, 8, ["modelValue", "options"]),
            (_ctx.filter.subscriptionId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter.subscriptionId = null))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('providers.isActive')), 1),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.active,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter.active = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.activityStatuses(),
              id: "provider-status-select",
              "close-on-select": true
            }, null, 8, ["modelValue", "options"]),
            (_ctx.filter.active != null)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filter.active = null))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('providers.registationDates')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dateChanged(_ctx.registrationDateRange))),
              modelValue: _ctx.registrationDateRange.fromDate,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.registrationDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dateChanged(_ctx.registrationDateRange))),
              modelValue: _ctx.registrationDateRange.toDate,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.registrationDateRange.toDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              minDate: _ctx.registrationDateRange.fromDate
            }, null, 8, ["modelValue", "minDate"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_29, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args))),
            class: "search-filter-button"
          }, _toDisplayString(_ctx.$t('button.search')), 1)
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
          }, _toDisplayString(_ctx.$t('button.close')), 1),
          _hoisted_31,
          _createVNode("button", {
            type: "button",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.ResetFilter && _ctx.ResetFilter(...args)))
          }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
        ])
      ])
    ])
  ]))
})